import { createSelector } from '@reduxjs/toolkit';
import { getFromImmutableState } from '../../../../../utils/immutableUtils';

export const getMetadata = getFromImmutableState((state) =>
  state.get('metadata'),
);

export const getDescription = createSelector(
  getMetadata,
  (metadata) => metadata.description,
);
